import "./Home.module.css";
import CabeceraPrincipal from "@/reusable_sections/Header";
import TuNegocioEnAlicanteDespegando from "./sections/TuNegocioEnAlicanteDespegando";
import ElProblemaDeLaInvisibilidad from "./sections/ElProblemaDeLaInvisibilidad";
import ScooterAndBicycleBatterySolutions from "./sections/ScooterAndBicycleBatterySolutions";
import EspecialidadesTecnicas from "./sections/EspecialidadesTecnicas";
import CompatibleBrands from "./sections/CompatibleBrands";
import TarifasTransparentesYEnviosATodaEspana from "./sections/TarifasTransparentesYEnviosATodaEspana";
import HablemosDeTuTransformacion from "./sections/HablemosDeTuTransformacion";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <meta name="description" content="Expertos en reparación de baterías de patinetes eléctricos en Sevilla. Recuperamos la autonomía de tu vehículo con garantía y rapidez. ¡Solicita tu diagnóstico gratuito ahora!" />
      <CabeceraPrincipal />
      <main>
        <TuNegocioEnAlicanteDespegando />
        <ElProblemaDeLaInvisibilidad />
        <ScooterAndBicycleBatterySolutions />
        <EspecialidadesTecnicas />
        <CompatibleBrands />
        <TarifasTransparentesYEnviosATodaEspana />
        <HablemosDeTuTransformacion />
      </main>
      <Footer />
    </div>;
}